import { createRouter, createWebHistory } from 'vue-router'

const routes = [
    {
        path: '/',
        name: 'iport',
        component: () => import('./views/iPort.vue'),
        meta: {
            title: 'iPort'
        },
    }
]

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes
})

router.beforeEach((to, from, next) => {
    next();

    if(to.meta.title){
        document.title = to.meta.title
    }
});

export default router
